import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'

// !COMPONENTS
import Layout from '@shared/components/layout'
import ChessHeader from '@shared/components/chessComponents/chessHeader'
import OlympicsTrendingNews from '@shared/components/olympics/olympicsTrendingNews'
import LatestArticles from '@shared/components/olympics/latestArticles'
import ChessTable from '@shared/components/chessComponents/scoreCard'
import LeagueTimeline from '@shared/components/chessComponents/leagueTimeline'
import Teams from '@shared/components/chessComponents/teams'
import ChessInterestingReads from '@shared/components/chessComponents/chessIntrestingReads'
import ChessPlayers from '@shared/components/chessComponents/players'
import HighlightArticle from '@shared/components/olympics/olympicsHighlights'
import ReviveAds from '@shared/components/reviveAds'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// !QUERY
import queryGraphql from '@shared/components/queryGraphql'
import { GET_CATEGORY_NEWS_VIDEOS } from '@graphql/series/home.query'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { GET_CHESS_LEAGUE, GET_GCL_STANDINGS } from '@graphql/chess/chess.query'
import { handleApiError, parallelCalls } from '@shared-submodule/utils'
import styles from './style.module.scss'
// import GoogleAds from '@shared-submodule/sm-components/googleAds'
// import { skyAddData } from '@shared/constants/skyAds'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import useWindowSize from '@shared/hooks/windowSize'
import { GRAPHQL_URL } from '@shared-submodule/sm-constants'

function Chess({ news, medal, seoData, teamData, playerData, league }) {
  const [width] = useWindowSize()
  const data = news?.listSimpleCategoryArticlesVideosFront?.oArticles

  const chessIntrestingReads = [
    {
      oSeo: {
        sSlug: 'https://www.oneturf.news/chess/all-about-the-global-chess-league-2024-opening-ceremony'
      },
      oImg: {
        sUrl: 'media/attachments/1727948740297_global-chess-league-2024-opening-ceremony.jpeg'
      },
      sSrtTitle: 'All about the Global Chess League 2024 opening ceremony'
    },
    {
      oSeo: {
        sSlug: 'https://www.oneturf.news/chess/where-to-watch-global-chess-league-2024'
      },
      oImg: {
        sUrl: 'media/attachments/1727950032289_gcl-streaming.jpeg'
      },
      sSrtTitle: 'Where to watch Global Chess League 2024?'
    },
    {
      oSeo: {
        sSlug: 'https://www.oneturf.news/chess/what-is-the-global-chess-league-check-details'
      },
      oImg: {
        sUrl: 'media/attachments/1727950967703_global-chess-league-.jpeg'
      },
      sSrtTitle: 'What is the Global Chess League? Check details'
    },
    {
      oSeo: {
        sSlug: 'https://www.oneturf.news/chess/who-won-the-global-chess-league-2023-check-details'
      },
      oImg: {
        sUrl: 'media/attachments/1727952451681_gcl-2023.jpeg'
      },
      sSrtTitle: 'Who won the Global Chess League 2023? Check details'
    }
  ]

  const { addRight } = reviveAdData
  return (
    <Layout
      data={{
        oSeo: {}
      }}>
      <>
        <ChessHeader />
        <Container>
          <div className="d-flex flex-column gap-4 pt-4">
            <Row className={styles.gap}>
              <Col xxl={3} className={`${styles.order} d-xxl-block d-none`}>
                {data?.aResults && <OlympicsTrendingNews data={data?.aResults?.slice(1, 9)} />}
              </Col>
              <Col xl={8} xxl={6} className={`${styles.centerContent}`}>
                {data?.aResults && <LatestArticles mainArticle={data?.aResults[0]} data={data?.aResults?.slice(9, 11)} />}
              </Col>
              <Col xl={4} xxl={3} className="common-sidebar mt-0">
                {medal && <ChessTable data={medal} />}
                {/* <GoogleAds
                  addId={skyAddData?.addRight?.addId}
                  divId={skyAddData?.addRight?.divId}
                  dimension={skyAddData?.addRight?.dimension}
                  slotId={skyAddData?.addRight?.slotId}
                  className={'my-3'}
                /> */}
                <ReviveAds {...addRight} className={'my-3'} />
              </Col>
            </Row>
            <div className="d-md-none d-block">{data?.aResults && <OlympicsTrendingNews data={data?.aResults?.slice(0, 8)} />}</div>
            {league && <LeagueTimeline data={league} />}
            <ChessInterestingReads data={chessIntrestingReads} />
            <Teams data={teamData} />
            <ChessPlayers data={playerData} />
            {data?.aResults && <HighlightArticle isChess article={data?.aResults?.[5]} />}
            {width < 767 && (
              // <GoogleAds
              //   addId={googleAddData?.mobLg?.addId}
              //   divId={googleAddData?.mobLg?.divId}
              //   dimension={googleAddData?.mobLg?.dimension}
              //   slotId={googleAddData?.mobLg?.slotId}
              //   className={'mt-0 mb-4'}
              // />
              <ReviveAds {...addRight} className={'mt-0 mb-4'} />
            )}
          </div>
        </Container>
      </>
    </Layout>
  )
}

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=600')
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: 'chess' } })
    const baseUrl = GRAPHQL_URL.replace(/\/graphql$/, '')
    const commonPayload = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      }
    }
    const response = await fetch(`${baseUrl}/api/match/chess-team`, commonPayload)
    const playerResponse = await fetch(`${baseUrl}/api/match/chess-player`, commonPayload)
    const playerData = await playerResponse.json()
    const teamData = await response.json()

    const [news, medal, league] = await parallelCalls([
      queryGraphql(GET_CATEGORY_NEWS_VIDEOS, {
        input: {
          nLimit: 60,
          nSkip: 0,
          iCategoryId: '6629023281a215dedeef005b',
          eType: 'vn'
        }
      }),
      queryGraphql(GET_GCL_STANDINGS),
      queryGraphql(GET_CHESS_LEAGUE)
    ])

    return {
      props: {
        news,
        medal: medal.getGCLStandings,
        seoData,
        teamData,
        playerData,
        league
      }
    }
  } catch (e) {
    console.error('Error fetching data:', e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

Chess.propTypes = {
  news: PropTypes.object,
  medal: PropTypes.object,
  seoData: PropTypes.object,
  teamData: PropTypes.object,
  playerData: PropTypes.object,
  league: PropTypes.object
}

export default Chess
